import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "upload-box__icon" }
const _hoisted_2 = { class: "upload-box__info" }
const _hoisted_3 = { class: "upload-box__subtitle" }
const _hoisted_4 = { class: "upload-box__subtitle" }

import IconUpload from "@/assets/icons/IconUpload.vue";
import {ref} from "vue";

interface Props {
  acceptedFormats?: string;
  maxSize?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadBox',
  props: {
    acceptedFormats: { default: "XLS" },
    maxSize: { default: "25 Мб" }
  },
  emits: ["upload"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const inputRef = ref<HTMLInputElement | null>(null);
const isDragging = ref(false);

const processFiles = (files: FileList) => {
  const modifiedFiles = Array.from(files).map(file => {
    return Object.assign(file, {
      file_name: file.name,
      file_size: file.size
    });
  });
  const dataTransfer = new DataTransfer();
  modifiedFiles.forEach(file => dataTransfer.items.add(file));
  emit("upload", dataTransfer.files);
};

const handleClick = () => {
  inputRef.value?.click();
};

const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    processFiles(target.files);
  }
};

const handleDragOver = (event: DragEvent) => {
  event.preventDefault();
  isDragging.value = true;
};

const handleDragLeave = () => {
  isDragging.value = false;
};

const handleDrop = (event: DragEvent) => {
  event.preventDefault();
  isDragging.value = false;

  if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
    processFiles(event.dataTransfer.files);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["upload-box", { 'upload-box--dragging': isDragging.value }]),
    onClick: handleClick,
    onDragover: handleDragOver,
    onDragleave: handleDragLeave,
    onDrop: handleDrop
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(IconUpload)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "upload-box__title" }, [
      _createTextVNode(" Перетащите файлы сюда или "),
      _createElementVNode("span", { class: "upload-box__title--active" }, "нажмите, что бы выбрать")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Поддерживаемый формат: " + _toDisplayString(__props.acceptedFormats), 1),
      _createElementVNode("span", _hoisted_4, "Макс. размер: " + _toDisplayString(__props.maxSize), 1)
    ]),
    _createElementVNode("input", {
      ref_key: "inputRef",
      ref: inputRef,
      style: {"display":"none"},
      type: "file",
      accept: ".xls,.xlsx",
      multiple: "",
      onChange: handleFileChange
    }, null, 544)
  ], 34))
}
}

})